export default __webpack_public_path__ + "static/car_insurance_products-6d8572cd3a41de31d07fdf55eba4f954.jpg";